export default __webpack_public_path__ + "static/71-71b681c09f12de5725aab27fa41560ca.jpg";